import { DEFAULT_CULTURE, getLanguageOptions } from './i18nLocale'

export function getLanguageID<T extends 'ID' | 'code'>(
  str: T,
  value: [T] extends ['ID'] ? number : string,
): [T] extends ['ID'] ? string : number {
  const options = getLanguageOptions()

  if (str === 'ID') {
    const id = value as number
    const match = options.find((o) => o.id === id)
    return (match?.nombreCultura ?? DEFAULT_CULTURE) as [T] extends ['ID'] ? string : number
  }

  const code = String(value)
  const match = options.find((o) => o.nombreCultura === code)
  return (match?.id ?? 1) as [T] extends ['ID'] ? string : number
}
